import React from "react";

import "./CloseBrowseTopicsButton.css";

const CloseBrowseTopicsButton = ({onClick, icon}) => {
  return (
    <button className="close-topics-button" onClick={onClick}>
      <div className="close-topics-button__overlap">
        <img
          className="close-topics-button__icon"
          alt="Lsicon close small"
          src={icon}
        />
        <div className="close-topics-button__text">Close Browse Topics</div>
      </div>
    </button>
  );
};

export default CloseBrowseTopicsButton;